import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./style/css/feather.css";
import "./index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "./style/icon/boxicons/boxicons/css/boxicons.min.css";
import Loader from "./core/common/loader";
import "./style/icon/weather/weathericons.css";
import "./style/icon/typicons/typicons.css";
import "./style/icon/fontawesome/css/fontawesome.min.css";
import "./style/icon/fontawesome/css/all.min.css";
import "./style/icon/ionic/ionicons.css";
import "./style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import { HelmetProvider } from 'react-helmet-async'
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer } from "react-toastify";
import SessionListener from "./feature-module/SessionListener";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
      gcTime: 10 * 60 * 1000,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  
  <React.StrictMode>
     <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <HelmetProvider>
        <HashRouter future={{ 
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}>
          <Loader />
          <SessionListener />
          <ALLRoutes />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </HashRouter>
      </HelmetProvider>
    </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
